<template>
    <div>
    <v-sheet color="blue-darken-4" elevation="10" max-width="600" rounded="lg" width="100%"
        class="pa-4 text-center mx-auto">
     <h2 class="text-h5 mb-1">
        DIRECCIÓN GENERAL DE LOGÍSTICA<br>
        UNIDAD DE MATERIAL BÉLICO
        </h2>
     
      </v-sheet>
    </div>
          </template>
          <script>
          </script>
    